import { render, staticRenderFns } from "./DexPromoDetailModal.vue?vue&type=template&id=6793179c"
import script from "./DexPromoDetailModal.vue?vue&type=script&lang=ts"
export * from "./DexPromoDetailModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports